import { render, staticRenderFns } from "./formFacture.vue?vue&type=template&id=7fadfbd9&"
import script from "./formFacture.vue?vue&type=script&lang=js&"
export * from "./formFacture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports